var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "m-avatar" }, [
    _c(
      "div",
      { staticClass: "w-100 d-flex align-items-center" },
      [
        _vm.userinfos != null
          ? [
              _c("div", { staticClass: "justify-content-center" }, [
                _c("div", { staticClass: "avatar-frame big" }, [
                  _c("img", {
                    staticClass: "img-fluid",
                    attrs: { src: _vm.showavatar }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "w-100 ml-4" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$translate("Phywe::Template.avatarHelloUser"))
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "font-weight-bold" }, [
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.showuser.firstName) }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    domProps: { innerHTML: _vm._s(_vm.showuser.lastName) }
                  })
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", [
                    _c("a", { attrs: { href: _vm.myaccount } }, [
                      _c("i", { staticClass: "icon-edit-black" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("a", { attrs: { href: _vm.wishlist } }, [
                      _c("i", { staticClass: "icon-wishlist_show-black" })
                    ])
                  ])
                ])
              ])
            ]
          : [
              _vm._m(0),
              _vm._v(" "),
              _c("div", { staticClass: "w-100 ml-4" }, [
                _c("div", [
                  _vm._v(
                    _vm._s(_vm.$translate("Phywe::Template.avatarHelloGuest"))
                  )
                ]),
                _c(
                  "a",
                  {
                    staticClass: "font-weight-bold link-black",
                    attrs: { href: _vm.userlogin }
                  },
                  [
                    _vm._v(
                      _vm._s(_vm.$translate("Phywe::Template.avatarRegister"))
                    )
                  ]
                )
              ])
            ]
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "justify-content-center" }, [
      _c("div", { staticClass: "avatar-frame big" }, [
        _c("img", {
          staticClass: "img-fluid",
          attrs: {
            src:
              "https://cdn02.plentymarkets.com/jd5w7us67fek/frontend/Onlineshop/Images/MyAccount/No-Image-85x85.jpg"
          }
        })
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }